<template>
  <div class="evolucion-empresa">
    <div class="dashboard-chart">
      <h4>Evolución de la Empresa</h4>
      <!-- <p class="description"><b-form-checkbox 
          id="totalesEmpresa"
          v-model="totalesEmpresa"
          :value="Boolean(true)"
          :unchecked-value="Boolean(false)">
          Totales Negocio
        </b-form-checkbox>
      </p> -->
    </div>
    <line-evolucion
      chartId="line-evolucion-empresa" 
      class="chart-wrapper"
      ref="evolucionEmpresa"
      :stepSize="parseInt(50000000)"
      :max="parseInt(400000000)"
      :yAxisCurrency="true">
    </line-evolucion>

    <bar-evolucion
      chartId="bar-evolucion-empresa" 
      class="chart-wrapper"
      ref="evolucionEmpresaBarras"
      :stepSize="parseInt(50000000)"
      :max="parseInt(400000000)"
      :yAxisCurrency="true">
    </bar-evolucion>

  <div class="dashboard-tabla-resultados">
    <div class="dashboard-tabla-resultados-data">
        <b-table hover
            responsive="sm" 
            class="table-dashboard"
            :busy="tableBusy"
            :items="resultadosEvolucion" 
            :fields="fields">
          <div slot="table-busy" class="text-center">
            <b-spinner class="table-spinner" label="Spinning" />
          </div>              
          <template v-slot:cell(periodo)="data">
            {{ data.item.periodo | periodo }}
          </template>
          <template v-slot:cell(ventas)="data">
            {{ data.item.ventas | moneda }}
          </template>
          <template v-slot:cell(compras)="data">
            {{ data.item.compras | moneda }}
          </template>
          <template v-slot:cell(gastos)="data">
            {{ data.item.gastos | moneda }}
          </template>
          <template v-slot:cell(impuestos)="data">
            {{ data.item.impuestos | moneda }}
          </template>
          <template v-slot:cell(sueldos)="data">
            {{ data.item.sueldos | moneda }}
          </template>
          <template v-slot:cell(egresosTotal)="data">
            {{ data.item.egresosTotal | moneda }}
          </template>
        </b-table>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import LineEvolucion from '../../charts/LineEvolucion.vue';
import BarEvolucion from '../../charts/Bar.vue';
import Mensaje from  '../../shared/msjModal.vue';
import { msjModal } from '../../../mixins/modalDialogs';

export default {
  name: 'DashboardEvolucionEmpresa',
  components: {
    LineEvolucion,
    BarEvolucion,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      resultadosEvolucion: [],

      fields: [
        { key: 'periodo' },
        {
          key: 'ventas',
          class: 'text-right',
        },
        {
          key: 'compras',
          class: 'text-right',
        },
        {
          key: 'gastos',
          class: 'text-right',
        },
        {
          key: 'impuestos',
          class: 'text-right',
        },
        {
          key: 'sueldos',
          class: 'text-right',
        },
        {
          key: 'egresosTotal',
          label: 'Total Egresos',
          class: 'text-right',
        },
      ],

      tableBusy: false,
      totalesEmpresa: false,

      // labels: [],
      // evolucionEmpresa: [],
      // evolucionEmpresaTabla: [],
      // evolucionEmpresaTotal: [],
      // evolucionEmpresaTotalTabla: [],
    }
  },
  methods: {
    getEvolucion() {
      this.$store.dispatch('resultadosAdministracion/getEvolucionEmpresa')
        .then(() => {
          this.$refs.evolucionEmpresa.render(this.$store.getters['resultadosAdministracion/resultadosEvolucionEmpresaPeriodos'], 
            this.$store.getters['resultadosAdministracion/resultadosEvolucionEmpresaTotal'],
            parseInt(this.$store.getters['resultadosAdministracion/resultadosEvolucionEmpresaStep']),
            parseInt(this.$store.getters['resultadosAdministracion/resultadosEvolucionEmpresaMax']));

          this.$refs.evolucionEmpresaBarras.render(this.$store.getters['resultadosAdministracion/resultadosEvolucionEmpresaPeriodos'], 
            this.$store.getters['resultadosAdministracion/resultadosEvolucionEmpresaBarras'],
            parseInt(this.$store.getters['resultadosAdministracion/resultadosEvolucionEmpresaStep']),
            parseInt(this.$store.getters['resultadosAdministracion/resultadosEvolucionEmpresaMax']));

          this.resultadosEvolucion = this.$store.getters['resultadosAdministracion/resultadosEvolucionEmpresaTotalTabla'];

          // this.labels = this.$store.getters['resultadosAdministracion/resultadosEvolucionEmpresaPeriodos'];
          // this.evolucionEmpresa = this.$store.getters['resultadosAdministracion/resultadosEvolucionEmpresa'];
          // this.evolucionEmpresaTabla = this.$store.getters['resultadosAdministracion/resultadosEvolucionEmpresaTabla'];
          // this.evolucionEmpresaTotal = this.$store.getters['resultadosAdministracion/resultadosEvolucionEmpresaTotal'];
          // this.evolucionEmpresaTotalTabla = this.$store.getters['resultadosAdministracion/resultadosEvolucionEmpresaTotalTabla'];

          // this.getResultadosEvolucion();
        })
        .catch(error => {
          console.log(error);
          // this.showErrorMsj(error)
        });
    },
    // getResultadosEvolucion() {
    //   if (this.totalesEmpresa) {
    //     this.$refs.evolucionEmpresa.render(this.labels, this.evolucionEmpresaTotal);
    //     this.resultadosEvolucion = this.evolucionEmpresaTotalTabla;
    //   } else {
    //     this.$refs.evolucionEmpresa.render(this.labels, this.evolucionEmpresa);
    //     this.resultadosEvolucion = this.evolucionEmpresaTabla;
    //   }
    // }
  },
  watch: {
    // 'totalesEmpresa' : function(newVal, oldVal) {
    //   this.getResultadosEvolucion();
    // },
  },
}
</script>

<style>
  .evolucion-empresa .chart-wrapper {
    position: relative;
    height: 350px;
    margin-bottom: 30px;
  }
  .evolucion-empresa .dashboard-tabla-resultados-data {
    min-height: 0 !important;
  }

  .evolucion-empresa .dashboard-chart h4 {
    margin-bottom: 5px;
  }
  .evolucion-empresa .dashboard-chart p.description label {
    font-size: 1em;
    font-style: italic;
    cursor: pointer;
    margin-bottom: 5px;    
  }
  .evolucion-empresa .dashboard-chart p.description .custom-checkbox .custom-control-label::before {
    height: 12px;
    width: 12px;
    left: -20px;    
  }
  .evolucion-empresa .dashboard-chart p.description .custom-checkbox .custom-control-label::after {
    top: 0.08rem;
    left: -1.35rem;    
  }
</style>
